/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { object, array } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SkeletonStyles from './SkeletonStyles';

const styles = (theme) => ({
    // Import Skeleton layout
    ...SkeletonStyles,

    // Page Elements
    root: {
        [theme.breakpoints.down(600)]: {
            padding: '0 16px',
        },
    },
    pageWrapper: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(23.4%, auto));',
        justifyContent: 'space-between',
        alignItems: 'center',
        gridAutoRows: '1fr',
        marginTop: '16px',
        '@media only screen and (max-width: 800px) and (min-width: 601px)': {
            gridTemplateColumns: 'repeat(3, 30.4%);',
        },
    },
    textBody: {
        marginBottom: '20px',
        height: '20px',
    },
    blockBody: {
        width: '100%',
        height: '86px',
        padding: '0px 4px',
        marginBottom: '12px',
        minHeight: '80px',
        [theme.breakpoints.down(600)]: {
            minHeight: '67px',
        },
    },
});

const SKUSelectorSkeleton = ({ classes, skus }) => (
    <div className={classes.root}>
        <div className={`${classes.textMW} ${classes.textBody}`} />
        <div className={`${classes.textLG}`} />
        <div className={classes.pageWrapper}>
            {skus.map(() => <div className={`${classes.blockBody} ${classes.block}`} />,
            )}
        </div>
    </div>
);
SKUSelectorSkeleton.propTypes = {
    classes: object.isRequired,
    skus: array.isRequired,
};

export default withStyles(styles)(SKUSelectorSkeleton);
